export default "__VITE_ASSET__b5807ba4__"